import { useFormContext } from 'react-hook-form';
import type { ConfigurationProfileSchema } from '../../schemas/production/configuration-profile.schema';
import { DeviceModel } from '../../types/production/configuration-profile';

export interface ITechnology {
  id: string;
  name: {
    brand: string;
    system: DeviceModel;
  };
}

export function useGeneralConfigurationProfileForm() {
  const form = useFormContext<ConfigurationProfileSchema>();

  const handleChangeServerOption = (input: 'ip' | 'dns', technology: ITechnology) => {
    switch (technology?.name.system) {
      case DeviceModel.DM_BWS_NB2:
        if (input === 'dns') {
          form.setValue('config.general.ip_primary.ip', '0.0.0.0');
          form.setValue('config.general.ip_primary.port', 0);
          form.setValue('config.general.ip_secondary.ip', '0.0.0.0');
          form.setValue('config.general.ip_secondary.port', 0);
        }
        break;

      default:
        if (input === 'dns') {
          form.unregister('config.general.ip_primary.ip');
          form.unregister('config.general.ip_primary.port');
          form.unregister('config.general.ip_secondary.ip');
          form.unregister('config.general.ip_secondary.port');
        } else if (input === 'ip') {
          form.unregister('config.general.dns_primary.address');
          form.unregister('config.general.dns_primary.port');
          form.unregister('config.general.dns_secondary.address');
          form.unregister('config.general.dns_secondary.port');
        }
        break;
    }
  };

  return {
    form,
    handleChangeServerOption,
  };
}
